import React from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import Mou from "../../CcpSchool/CcpSchoolAccountProfile/inc/Mou";
import StudentApplicationApproval from "../../CcpSchool/CcpSchoolAppsAndTesting/inc/StudentApplicationApproval";
import StudentApplicationReport from "../../CcpSchool/CcpSchoolAppsAndTesting/inc/StudentApplicationReport";
import StudentTestScores from "../../CcpSchool/CcpSchoolAppsAndTesting/inc/StudentTestScores";
import AdditionalReports from "../../CcpSchool/CcpSchoolAppsAndTesting/inc/AdditionalReports";
import AdditionalGradeReport from "../../CcpSchool/CcpSchoolReports/inc/AdditionalGradeReport";
import AdditionalRegReport from "../../CcpSchool/CcpSchoolReports/inc/AdditionalRegReport";
import CoursePlanning from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/CoursePlanning";
import CurrentCourseSchedule from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/CurrentCourseSchedule";
import RestrictedCourseRosterFall from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/RestrictedCourseRosterFall";
import RestrictedCourseRosterSpring from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/RestrictedCourseRosterSpring";
import RostersInProgress from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/RostersInProgress";
import AdditionalResReport from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/AdditionalReport";
import AdditionalStudentReport from "../../CcpSchool/CcpStudentInfo/inc/AdditionalReports";
import SpecialFundingFall from "../../CcpSchool/CcpStudentInfo/inc/SpecialFundingFall";
import SpecialFundingSpring from "../../CcpSchool/CcpStudentInfo/inc/SpecialFundingSpring";
import SSID from "../../CcpSchool/CcpStudentInfo/inc/SSID";

const DistrictSchoolReports = ({ open, onClose, schoolId }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>School Reports</ModalDialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Mou schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <StudentApplicationApproval schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <StudentApplicationReport schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <StudentTestScores schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AdditionalReports schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AdditionalGradeReport schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AdditionalRegReport schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <CoursePlanning schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <CurrentCourseSchedule schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <RestrictedCourseRosterFall schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <RestrictedCourseRosterSpring schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <RestrictedCourseRosterSpring schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <RostersInProgress schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AdditionalResReport schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AdditionalStudentReport schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <SpecialFundingFall schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <SpecialFundingSpring schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <SSID schoolId={schoolId} />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DistrictSchoolReports;
